import React from 'react';
import { Modal, ModalTitle } from 'react-bootstrap';
import { useBuilderContext } from '../BuilderContext';
import CreateTemplateForm from './CreateTemplateForm';

const propTypes = {};

const defaultProps = {};

function CreateTemplateModal() {
    const { showCreateModal } = useBuilderContext();

    if (showCreateModal) {
        return (
            <Modal backdrop="static" show>
                <Modal.Header>
                    <ModalTitle role="heading">Create Protocol Template</ModalTitle>
                </Modal.Header>
                <CreateTemplateForm />
            </Modal>
        );
    }

    return false;
}

CreateTemplateModal.propTypes = propTypes;
CreateTemplateModal.defaultProps = defaultProps;

export default CreateTemplateModal;
